export const RULE_DATA_POOL_KEY_SET = 'serviceData.RULE_DATA_POOL_KEY_SET';
export const RULE_DATA_POOL_KEY_SET_COMMIT = 'serviceData.RULE_DATA_POOL_KEY_SET_COMMIT';
